import React from 'react';

import { useSelector } from 'react-redux';

import { ObjectStorageIcon } from 'components/Icons';
import { AnalyzedCard } from 'containers/Visibility/Data/Components/Dashboard/Cards/AnalyzedCard';
import { selectDataDashboard } from 'containers/Visibility/Data/selectors';

export const BucketsCard = () => {
  const {
    analyzedSources,
    summaryOfAllDataSources,
    sensitiveDataByAgnosticSources,
  } = useSelector(selectDataDashboard);
  const dataSources = summaryOfAllDataSources.data?.resource_type_counts;
  const sensitiveData = sensitiveDataByAgnosticSources.data;

  return (
    <AnalyzedCard
      label="Buckets"
      total={dataSources?.Buckets ?? 0}
      isLoading={analyzedSources.isLoading}
      icon={<ObjectStorageIcon />}
      analyzed={analyzedSources.data?.Buckets ?? 0}
      sensitiveDataCount={sensitiveData?.Buckets ?? 0}
    />
  );
};
